// extracted by mini-css-extract-plugin
export default {"text":"EstimatedGasFee_text__nJ8jK","cta":"EstimatedGasFee_cta__JCvh7","bodyPop":"EstimatedGasFee_bodyPop__EUWk2"};